import * as React from 'react'
import { Link as RRLink, LinkProps as RRLinkProps } from 'react-router-dom'

interface LinkProps
  extends React.HTMLAttributes<HTMLAnchorElement>,
    Partial<RRLinkProps> {}

const ForwardedRRLink = React.forwardRef(function ForwardedRRLink(
  props: RRLinkProps,
  ref: React.Ref<HTMLAnchorElement>,
) {
  return <RRLink innerRef={ref} {...props} />
})

const Link = React.forwardRef(function Link(
  props: LinkProps,
  ref: React.Ref<HTMLAnchorElement>,
) {
  const Element = props.to ? (ForwardedRRLink as any) : 'a'
  return <Element {...props} ref={ref} />
})

export default Link
